import { useMemo } from 'react';

import { MicrosoftIntegrationStatus } from '@this+that/models';

import { useIntegrationsStore } from '../../store/Inbox/Integrations/useIntegrationsStore';

export function useTeamsIntegrations(): MicrosoftIntegrationStatus[] {
  const userMicrosoftIntegrations = useIntegrationsStore(
    (s) => s.userMicrosoftIntegrations,
  );
  return useMemo(
    () => userMicrosoftIntegrations.filter((i) => i.teamsEnabled),
    [userMicrosoftIntegrations],
  );
}
